export default __webpack_public_path__ + "static/media/marketwatch.eb1d7301.png";